import { render, staticRenderFns } from "./ecological.vue?vue&type=template&id=37b4a016&scoped=true"
var script = {}
import style0 from "./ecological.vue?vue&type=style&index=0&id=37b4a016&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b4a016",
  null
  
)

export default component.exports